export default __webpack_public_path__ + "static/media/points.84d325d7.svg";